<template>
  <ts-card>
    <div
      class="form-header ts-bg-gray-100 ts-border-b ts-border-gray-400 ts-p-4 ts-relative ts-flex ts-items-center ts-justify-between"
      style="min-height: 60px;"
    >
      <h4 class="ts-text-sm m-0">
        {{
          $t('school.academic.operation.profile_mgt.studentProfile.previewCard')
        }}
      </h4>

      <div class="ts-flex ts-items-center ts-justify-end">
        <div class="ts-mr-8">
          <ts-button
            outline
            @click="downloadAll"
            v-tooltip="$t('downloadAll')"
            style="min-width: 140px;"
            :disabled="loading"
          >
            <i class="fa fa-download ts-mr-3"></i>
            {{ $t('downloadAll') }}
          </ts-button>
        </div>
        <ts-modal-close-button />
      </div>
    </div>

    <ts-loading-banner :loading="loading">
      <ts-card-wrapper>
        <div
          class="table-responsive drive-items-table-wrapper ts-overflow-y-auto ts-overflow-x-hidden"
          style="max-height: 65vh;"
        >
          <table class="table table-hover text-nowrap">
            <thead>
              <tr>
                <th class="type">Student Card</th>
                <th class="studentName">Student Name</th>
                <th class="studentCardSide">Card Side</th>
                <th class="text-center" width="1%">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(urlImage, index) in urlImages"
                :key="index"
                class="ts-cursor-pointer"
              >
                <td class="type" valign="bottom">
                  <img
                    class="h-full w-full rounded-lg object-cover shadow-lg"
                    :icon-size="iconSize"
                    :src="urlImage.url"
                    alt=""
                    v-viewer="{ toolbar: false }"
                    loading="lazy"
                    style="max-height: 106px;"
                  />
                </td>
                <td class="employeeName" valign="bottom">
                  {{ urlImage.student_name }}
                </td>
                <td class="employeeName" valign="bottom">
                  {{ urlImage.side }}
                </td>
                <td class="text-center ts-space-x-2" valign="bottom">
                  <a
                    @click.prevent="download(urlImage.url)"
                    v-tooltip="'Download'"
                    class="text-primary"
                    ><i class="fa fa-download"></i
                  ></a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </ts-card-wrapper>
    </ts-loading-banner>
  </ts-card>
</template>
<script>
import Vue from 'vue'
import 'viewerjs/dist/viewer.css'
import VueViewer from 'v-viewer'
Vue.use(VueViewer)
import * as FileDownload from 'downloadjs'
export default {
  name: 'previewCardDownload',
  props: {
    id_list: {
      type: Array
    },
    side: {
      type: String
    },
    type: {
      type: String
    },
    valid_date: {
      type: String
    }
  },
  data() {
    return {
      iconSize: 'fa-2x',
      loading: false,
      urlImages: []
    }
  },
  created() {
    this.previewCardDownload()
  },
  methods: {
    previewCardDownload() {
      this.loading = true
      this.$store
        .dispatch('studentProfile/printCard', {
          student_id_list: this.id_list,
          side: this.side,
          type: this.type,
          valid_date: this.valid_date
        })
        .then(response => {
          this.$toasted.success(response.message)
          this.loading = false
          this.urlImages = response.url_images
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.loading = true
        })
    },
    download(data) {
      FileDownload(data)
    },
    downloadAll() {
      if (!this.urlImages || this.urlImages.length === 0) {
        this.$toasted.info('No images to download')
        return
      }

      this.urlImages.forEach(image => {
        this.download(image.url)
      })
    }
  }
}
</script>
